import { Avatar, Box, Chip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFillingPersonThunk } from "store/reducers/machine_func/machineAssignments";
import addURLPrefix from "utils/addURLPrefix";

const AssignedFillingPersons = ({ filling_persons, machine_id }) => {
  const dispatch = useDispatch();
  const fillingPersonRemoveLoading = useSelector(
    (state) => state.vending.fillingPersonRemoveLoading
  );
  const deleteFillingPerson = (filling_person) => {
    dispatch(
      removeFillingPersonThunk({ filling_person: filling_person.id, machine: machine_id })
    );
  };
  return (
    <Box>
      {filling_persons.map((filling_person) => (
        <Chip
          key={filling_person.id}
          avatar={
            filling_person.photo ? (
              <Avatar alt="Filling photo" src={addURLPrefix(filling_person.photo)} />
            ) : (
              <Avatar>{filling_person.first_name[0]}</Avatar>
            )
          }
          label={`${filling_person.first_name} ${filling_person.last_name}`}
          margin={2}
          {...(!fillingPersonRemoveLoading[filling_person.id] && {
            onDelete: () => deleteFillingPerson(filling_person),
          })}
        />
      ))}
    </Box>
  );
};

export default AssignedFillingPersons;
